module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/navigation/arrow-down-33c12dfc709bb7b0052898bb7b44848d.svg";